import groundcover, { type Redactor } from '@groundcover/browser'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import defu from 'defu'

export type GroundcoverParams = NonNullable<
  Parameters<typeof groundcover.init>[0]
>

const REDACTED = '[REDACTED]'

// ponytail: unparsed bodies (>100KB or non-JSON) are dropped whole
export const redact: Redactor = ({ key, kind }) =>
  key === '' && kind.endsWith('-body') ? REDACTED : undefined

export default defineNuxtPlugin({
  name: 'nuxt-groundcover',
  setup(nuxtApp) {
    const { config } = useRuntimeConfig().public.groundcover ?? {}

    // ponytail: dsn/cluster hardcoded until multiple backends/regions exist
    const groundcoverParams = defu(config, {
      dsn: 'https://tevicq4nl.platform.grcv.io',
      cluster: 'workflows-apps',
      options: {
        privacy: {
          level: 'mask-sensitive',
          sensitiveKeys: [
            'contained',
            'insurance',
            'patient_',
            'birth',
            'subscriber',
            'beneficiary',
            'member_',
          ],
          redact,
          maskSelectors: ['[data-dd-privacy="mask"]'],
        },
      },
    }) as GroundcoverParams

    groundcover.init(groundcoverParams)

    groundcover.startReplayRecording()

    // vue's default warn logs raw vnodes that the SDK serializes whole; groundcoverIgnore drops the event
    nuxtApp.vueApp.config.warnHandler = (msg, _instance, trace) =>
      console.warn(`[Vue warn]: ${msg}\n${trace}`, { groundcoverIgnore: true })

    return {
      provide: {
        groundcover,
      },
    }
  },
})
